var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-tip"},[(_vm.icon)?[_c('Icon',{staticClass:"pro-tip__icon",attrs:{"name":_vm.icon,"size":"medium"}}),_c('span',[_vm._t("default")],2)]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }